"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBudgetDateRange = void 0;
const luxon_1 = require("luxon");
const getBudgetDateRange = (year, month) => {
    const startDate = luxon_1.DateTime.fromObject({ year, month });
    const endDate = startDate.endOf('month');
    return { startDate, endDate };
};
exports.getBudgetDateRange = getBudgetDateRange;
